/**
 * ShopFavoritesList - Список избранных товаров
 */

import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ucpService } from "../../api/services/ucpService";
import { getShopImageCandidates } from "../../utils/helpers";

const ShopFavoritesList = () => {
    const navigate = useNavigate();
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [items, setItems] = useState([]);
    const [favorites, setFavorites] = useState(new Set());
    const [loadingText, setLoadingText] = useState("Загрузка...");
    const [isLoading, setIsLoading] = useState(true);

    const fetchFavorites = async () => {
        setIsLoading(true);
        setLoadingText("Загрузка...");
        try {
            const [favoriteIds, allItems] = await Promise.all([
                ucpService.getFavouriteItems(),
                ucpService.getShopItems(),
            ]);
            const favoriteSet = new Set(favoriteIds || []);
            setFavorites(favoriteSet);
            setItems(
                (allItems || []).filter((item) => favoriteSet.has(item.id)),
            );
        } catch (err) {
            console.error("Ошибка загрузки избранного:", err.message);
            setItems([]);
            setFavorites(new Set());
            setLoadingText("Не удалось загрузить избранное.");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchFavorites();
    }, []);

    const handleBuyItem = (itemId) => {
        navigate(`/ucp/shop/buy?item_id=${encodeURIComponent(itemId)}`);
    };

    const toggleFavorite = async (itemId) => {
        try {
            if (favorites.has(itemId)) {
                await ucpService.deleteFromFavourites(itemId);
                setFavorites((prev) => {
                    const next = new Set(prev);
                    next.delete(itemId);
                    return next;
                });
                setItems((prev) => prev.filter((item) => item.id !== itemId));
            }
        } catch (err) {
            console.error("Ошибка при обновлении избранного:", err.message);
        }
    };

    return (
        <SimpleBar
            className="simplebar-track-shop"
            style={{ overflowY: "auto" }}
        >
            <div className="shop-cards-container">
                {items.length > 0 ? (
                    items.map((item) => (
                        <div
                            key={item.id}
                            className="shop-card"
                            onMouseEnter={() => setHoveredIndex(item.id)}
                            onMouseLeave={() => setHoveredIndex(null)}
                        >
                            <div className="information-container-body-shop">
                                <img
                                    src={getShopImageCandidates(item.imgUrl)[0]}
                                    alt={item.name || "favorite item"}
                                    loading="lazy"
                                    onError={(event) => {
                                        const candidates =
                                            getShopImageCandidates(item.imgUrl);
                                        const currentIndex = Number(
                                            event.currentTarget.dataset
                                                .candidateIndex || 0,
                                        );
                                        const nextIndex = currentIndex + 1;
                                        if (nextIndex >= candidates.length) {
                                            return;
                                        }
                                        event.currentTarget.dataset.candidateIndex =
                                            String(nextIndex);
                                        event.currentTarget.src =
                                            candidates[nextIndex];
                                    }}
                                />
                                <button
                                    className="shop-favorite-button active"
                                    onClick={() => toggleFavorite(item.id)}
                                ></button>
                            </div>
                            <span className="shop-card-title">{item.name}</span>
                            <button
                                className="shop-primary-button shop-card-buy-button"
                                type="button"
                                onClick={() => handleBuyItem(item.id)}
                            >
                                {hoveredIndex === item.id
                                    ? "КУПИТЬ"
                                    : `${item.price} MD`}
                            </button>
                        </div>
                    ))
                ) : (
                    <p className="loading-text">
                        {isLoading
                            ? loadingText
                            : "Не найдено товаров в избранном."}
                    </p>
                )}
            </div>
        </SimpleBar>
    );
};

export default ShopFavoritesList;
